import { z } from "zod";
import { SearchItemSchema } from "./search-item";

export const SearchResultSchema = z.object({
  Count: z.number().optional(),
  Value: SearchItemSchema.array(),
});

export type SearchResultType = z.infer<typeof SearchResultSchema>;
